import React, { useState } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import { ToolTip } from "../Tooltip/ToolTip";
import * as Constants from "../../../constants/Constants";
const DunsWrapper = (props) => {
  const {
    onChange,
    dunsValidationStatus,
    dunsErrorStatus,
    dunValidationMsg,
    dunValidationErrorMsg,
    duns,
    validateDunsAlreadyExist,
    isDunsValidated,
    isValidDunsNumber,
    dunsCheckMarkSatus,
    hasErrorIndex,
    disabled,
    dunsExistingValue,
    type,
    dunsExists,
    colSize,
    isPrimaryVendor,
    style,
    hasValidateBtn = true,
    reValidateFlag
  } = props;

  const getValidate = () => {
    if (isDunsValidated && type !== "duns") {
      return false;
    } else if (
      (type === "duns" && dunsExistingValue) ||
      (type === "duns" &&
        !dunsExistingValue &&
        isDunsValidated &&
        !dunValidationErrorMsg)
    ) {
      return false;
    } else if (
      !dunsExistingValue &&
      !dunsValidationStatus &&
      !dunValidationErrorMsg
    ) {
      return true;
    } else if (
      dunValidationErrorMsg &&
      !dunsValidationStatus &&
      !isDunsValidated
    ) {
      return true;
    }
    return type === "duns" && !dunsExistingValue ? false : !isDunsValidated;
  };

  return (
    <div>
      <div style={{ display: "flex" }}>
        <Form.Group as={Col} md={colSize ? colSize : 8}>
          <ToolTip
            toolTipId="toolTipDuns"
            customStyles="compDetailsFormLabel"
            label={Constants.DUNS_LABEL}
            mandate={false}
            toolTipText={Constants.DUNS_LABEL_HELP_TEXT}
          />
          <Form.Control
            type="text"
            id="duns"
            name="duns"
            placeholder={Constants.DUNS_PLACE_HOLDER}
            onChange={(e) => onChange("duns", e)}
            value={duns || ""}
            maxLength="9"
            disabled={disabled}
            className={hasErrorIndex === 13 ? "has-error" : ""}
          />
        </Form.Group>
        {dunsCheckMarkSatus && (
          <Form.Group>
            <i className="checkMark"></i>
          </Form.Group>
        )}
        <Form.Group as={Col} md={4}>
          {hasValidateBtn && (
            <>
              {((!type || isPrimaryVendor) && (reValidateFlag)) && (
                <Button
                  id="validateDunsBtn"
                  size="md"
                  disabled={disabled}
                  className={
                    (!isDunsValidated && type != "duns") || getValidate()
                      ? "button-primary-md"
                      : "button-secondary-md"
                  }
                  style={{ marginTop: 22 }}
                  onClick={validateDunsAlreadyExist}
                >
                  {isDunsValidated || (dunsExistingValue && type === "duns")
                    ? Constants.BUTTON_REVALIDATE
                    : Constants.BUTTON_VALIDATE}
                </Button>
              )}
            </>
          )}
        </Form.Group>
      </div>
      <div style={{ marginLeft: 20, marginTop: "-18px", marginBottom: 10 }}>
        {dunsValidationStatus && !dunsExists && (
          <p className="validationSuccessMsg">{dunValidationMsg}</p>
        )}
        {!isValidDunsNumber && !dunsExists && (
          <p className="validationErrorMsg">{dunValidationErrorMsg}</p>
        )}
        {dunsErrorStatus && !dunsExists && (
          <p className="validationErrorMsg">
            {type === "duns"
              ? Constants.DUNS_DVN_EXISTS_VALIDATION_ERROR_MSG
              : Constants.DUNS_EXISTS_VALIDATION_ERROR_MSG}
          </p>
        )}
        {dunsExists && (
          <p className="validationErrorMsg">
            {Constants.DUNS_DVN_EXISTS_VALIDATION_ERROR_MSG}
          </p>
        )}
      </div>
    </div>
  );
};
export default DunsWrapper;
